"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _PageButton = _interopRequireDefault(require("./PageButton.index"));

var _Pagination = require("./Pagination.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var numberAtLeast = function numberAtLeast(min) {
  return function (props, propName, componentName) {
    var prop = props[propName];

    if (typeof prop !== 'number' || prop < min) {
      return new Error("Prop ".concat(propName, " must be a number greater than ").concat(min, " on ").concat(componentName));
    }

    return null;
  };
};

var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      maxPageDisplay = _ref.maxPageDisplay,
      pageSize = _ref.pageSize,
      paginationChange = _ref.paginationChange,
      resultCount = _ref.resultCount,
      showGoToPage = _ref.showGoToPage,
      showTotalTracker = _ref.showTotalTracker;
  var pageCount = Math.ceil(resultCount / pageSize);

  var _useState = (0, _react.useState)(1),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectedPage = _useState2[0],
      setSelectedPage = _useState2[1];

  (0, _react.useEffect)(function () {
    if (currentPage <= 0) setSelectedPage(1);else if (currentPage > pageCount) setSelectedPage(pageCount);else setSelectedPage(currentPage);
  }, [currentPage, pageCount, setSelectedPage]);
  var handlePageChange = (0, _react.useCallback)(function (newPage) {
    setSelectedPage(newPage);
    paginationChange(newPage, pageSize);
  }, [pageSize, paginationChange, setSelectedPage]);
  var handleGoToPage = (0, _react.useCallback)(function (event) {
    var input = event.target;
    var newPage = parseInt(input.value, 10);

    if (Number.isInteger(newPage) && newPage > 0 && newPage < pageCount) {
      setSelectedPage(newPage);
      paginationChange(newPage, pageSize);
      input.value = '';
    }
  }, [pageCount, pageSize, paginationChange, setSelectedPage]);
  var firstItemIndex = (selectedPage - 1) * pageSize + 1;
  var lastItemIndex = Math.min(resultCount, selectedPage * pageSize);
  var maxPerSideCount = Math.floor((maxPageDisplay - 3) / 2); // Less 1 for selected and 2 more for first and last

  var showLeftTrunk = selectedPage - maxPerSideCount > 2;
  var showRightTrunk = selectedPage + maxPerSideCount < pageCount - 2;
  var pageButtons = [];
  var firstButtonVal = 2;
  var lastButtonVal = pageCount - 1;

  if (showLeftTrunk && showRightTrunk) {
    // 1 ... 2 3 4 ... 7
    firstButtonVal = selectedPage - maxPerSideCount;
    lastButtonVal = selectedPage + maxPerSideCount;
  } else if (showLeftTrunk) {
    // 1 ... 4 5 6 7
    firstButtonVal = pageCount - (maxPageDisplay - 2);
  } else if (showRightTrunk) {
    // 1 2 3 4 ... 7
    lastButtonVal = maxPageDisplay;
  }

  var _loop = function _loop(i) {
    pageButtons.push( /*#__PURE__*/_react["default"].createElement(_PageButton["default"], {
      selected: i === selectedPage,
      key: "page_".concat(i),
      onClick: function onClick() {
        return handlePageChange(i);
      },
      label: "".concat(i)
    }));
  };

  for (var i = firstButtonVal; i <= lastButtonVal; i += 1) {
    _loop(i);
  }

  return /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPaginationContainer, null, showTotalTracker && /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPageTrackerContainer, null, "".concat(firstItemIndex, "-").concat(lastItemIndex, " out of ").concat(resultCount, " Results")), showGoToPage && /*#__PURE__*/_react["default"].createElement(_Pagination.StyledGoToPageContainer, null, /*#__PURE__*/_react["default"].createElement("span", null, "Go To"), /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPageInput, {
    hideOptionalText: true,
    id: "paginationGoTo",
    label: "page #",
    onBlur: handleGoToPage
  })), /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPageSelectContainer, null, /*#__PURE__*/_react["default"].createElement(_PageButton["default"], {
    disabled: selectedPage === 1,
    wide: true,
    onClick: function onClick() {
      return handlePageChange(selectedPage - 1);
    },
    label: "Prev",
    prepend: /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPageButtonLeftIcon, null)
  }), /*#__PURE__*/_react["default"].createElement(_PageButton["default"], {
    selected: selectedPage === 1,
    onClick: function onClick() {
      return handlePageChange(1);
    },
    label: "1"
  }), showLeftTrunk && /*#__PURE__*/_react["default"].createElement(_PageButton["default"], {
    disabled: true,
    label: "..."
  }), pageButtons, showRightTrunk && /*#__PURE__*/_react["default"].createElement(_PageButton["default"], {
    disabled: true,
    label: "..."
  }), pageCount > 1 && /*#__PURE__*/_react["default"].createElement(_PageButton["default"], {
    selected: selectedPage === pageCount,
    onClick: function onClick() {
      return handlePageChange(pageCount);
    },
    label: "".concat(pageCount)
  }), /*#__PURE__*/_react["default"].createElement(_PageButton["default"], {
    disabled: selectedPage === pageCount,
    onClick: function onClick() {
      return handlePageChange(selectedPage + 1);
    },
    label: "Next",
    wide: true,
    append: /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPageButtonRightIcon, null)
  })));
};

Pagination.defaultProps = {
  currentPage: 1,
  maxPageDisplay: 7,
  paginationChange: function paginationChange() {},
  showGoToPage: false,
  showTotalTracker: false
};
Pagination.propTypes = {
  /** Starting page of the pagination. */
  currentPage: numberAtLeast(1),

  /** The maximum number of page options to display before truncating results. First and last are always visible. Maximum number of cards will be this +2 for the '...' cards */
  maxPageDisplay: _propTypes.number,

  /** The number of results per page. */
  pageSize: _propTypes.number.isRequired,

  /** Call back when selected page is updates. Args: currentPage, pageSize */
  paginationChange: _propTypes.func,

  /** The total number of results being paged through. */
  resultCount: _propTypes.number.isRequired,

  /** When supplied, show a Go To Page text input. */
  showGoToPage: _propTypes.bool,

  /** When supplied, show a "X of Y results" tracker. */
  showTotalTracker: _propTypes.bool
};
Pagination.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Pagination",
  "props": {
    "currentPage": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "description": "Starting page of the pagination.",
      "type": {
        "name": "custom",
        "raw": "numberAtLeast(1)"
      },
      "required": false
    },
    "maxPageDisplay": {
      "defaultValue": {
        "value": "7",
        "computed": false
      },
      "description": "The maximum number of page options to display before truncating results. First and last are always visible. Maximum number of cards will be this +2 for the '...' cards",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "paginationChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Call back when selected page is updates. Args: currentPage, pageSize",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "showGoToPage": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "When supplied, show a Go To Page text input.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showTotalTracker": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "When supplied, show a \"X of Y results\" tracker.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "pageSize": {
      "description": "The number of results per page.",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "resultCount": {
      "description": "The total number of results being paged through.",
      "type": {
        "name": "number"
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Pagination);

exports["default"] = _default;